import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "m18.7 3.25-2.765 2.763h-1.948V4.066l2.763-2.764a4.794 4.794 0 0 0-6.807 5.833L1.324 15.75a2.069 2.069 0 1 0 2.926 2.926l8.617-8.62A4.794 4.794 0 0 0 18.7 3.249v.001Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}) }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 0h20v20H0z" })
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cg%3E%3Cpath%20d%3D%22m18.7%203.25-2.765%202.763h-1.948V4.066l2.763-2.764a4.794%204.794%200%200%200-6.807%205.833L1.324%2015.75a2.069%202.069%200%201%200%202.926%202.926l8.617-8.62A4.794%204.794%200%200%200%2018.7%203.249v.001Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h20v20H0z%22%20%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
